import { memo, useMemo } from "react";

import classNames from "common/class-names";

import AppButtonDto from "dto/components/app-button-dto";

const AppButton = (p: AppButtonDto) => {
	const { label, icon, className, outline, large, text, small, smallRadius, ...props } = p;

	const buttonClassNames = useMemo(() => {
		return classNames({
			"app-button": true,
			"app-button--small": Boolean(small),
			"app-button--text": Boolean(text),
			"app-button--outline": Boolean(outline),
			"app-button--large": Boolean(large),
			"app-button--small-radius": Boolean(smallRadius),

			...(className && { [className]: true }),
		});
	}, [small, text, outline, large, smallRadius, className]);

	return (
		<button className={buttonClassNames} {...props}>
			<div className="button">
				<p className="button__label">{label}</p>

				{icon}
			</div>
		</button>
	);
};

export default memo(AppButton);
